import { useState } from 'react';
import ReactDOM from 'react-dom';
import { useInterval } from 'usehooks-ts'; // Assuming you're using this hook

interface DeferredPortalProps {
    portalId: string;
    children: React.ReactNode;
}

export function DeferredPortal({ portalId, children }: DeferredPortalProps) {
    const [isReady, setIsReady] = useState(false);
    const getContainer = () => document.querySelector(`#${portalId}`);

    useInterval(
        () => {
            const target = getContainer();
            if (!target) return;

            setIsReady(true);
        },
        isReady ? null : 500
    );

    const target = getContainer();
    if (!isReady || !target) return null;

    return ReactDOM.createPortal(children, target);
}
